var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTimeIntelligence404Icon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 330.834,
    height: 330.834,
    viewBox: "0 0 330.834 330.834",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-795 -350)",
    opacity: 0.56
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(795 350)",
    opacity: 0.56
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0H330.834V330.834H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.695,209.771,303.127,182.2,303.264,3H27.569V182.2l27.569,27.569H0v27.569H330.834V209.771ZM55.139,30.569H275.695V182.2H55.139ZM165.417,223.556A13.785,13.785,0,1,1,179.2,209.771,13.825,13.825,0,0,1,165.417,223.556Z",
    transform: "translate(0 38.354)",
    fill: "#424242"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(896 431.779)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0H128.442V128.442H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.842,30.759A13.379,13.379,0,1,0,66.221,44.138,13.384,13.384,0,0,0,52.842,30.759ZM109.035,4H2V89.628H109.035ZM81.153,80.049,65.579,64.475a23.73,23.73,0,0,1-12.791,3.746,24.238,24.238,0,1,1,20.39-11.292l15.574,15.52-7.6,7.6Z",
    transform: "translate(8.704 17.407)",
    fill: "#bdbdbd"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeIntelligence404Icon);
export default __webpack_public_path__ + "static/media/TimeIntelligence_404_Icon.bcb195433ec4dad5280b6b062aab85fc.svg";
export { ForwardRef as ReactComponent };